module.exports = __webpack_public_path__ + "static/media/tl7.b4ad2323.webp";